import * as React from "react";


import { getRoutePath, redirectToRoutePath, cleanUpNumericValue, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

interface IYearBuiltStepState extends IStepState {
    year?: string;
    yearError?: string;
}

export class YearBuiltStep extends React.Component<IStepProps, IYearBuiltStepState> {
    state: IYearBuiltStepState;

    constructor(props: IStepProps) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.continueButton = React.createRef();

        this.state = {
            year: this.props.model.homeAddon.yearBuilt,
            yearError: "",
            redirectPath: "",
            goToNextStep: false
        }
    }

    handleOnChange(event: React.ChangeEvent<HTMLInputElement>): void {
        let valueElement = event.target as HTMLInputElement;
        let value = valueElement.value;

        const cleanYearBuilt = cleanUpNumericValue(value);

        this.setState({ year: cleanYearBuilt });
    }

    handleOnClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        if (!this.yearIsValid(this.state.year)) {
            this.setState({ yearError: "Please enter a valid year" });
            return;
        }

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.homeAddon.yearBuilt = this.state.year;

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.HOME_ADDON_PROPERTY_TYPE);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>): void {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.continueButton.current.click();
        }
    }

    yearIsValid(year: string): boolean {
        var text = /^[0-9]+$/;

        if (year.length === 4 && parseInt(year) !== 0) {

            if ((year != "") && (!text.test(year))) {
                return false;
            }

            return true;
        }

        return false;
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }

        const error = this.state.yearError.length > 0 ? <span id="YearBuiltValue_Error" className="field-invalid-text">{this.state.yearError}</span> : "";

        return <React.Fragment>
            <LogStep lastStep="Bundle" nextStep="PropertyType" stepNumber={QuoteFormEventType.YearBuiltStep} sectionName="YearBuilt" wizardName="AutoWizard" logStep={true}/>
            <div id="YearBuiltStep" className={sectionClasses} style={sectionStyle}>
                   <h3>Year Built (OK to estimate)</h3>
                    <div id="YearBuilt">
                        {error}
                <input type="tel" id="YearBuiltValue" maxLength={4} placeholder="####" required pattern="[1-2][0,9]\d\d" value={this.state.year} onChange={this.handleOnChange} onKeyDown={this.handleKeyDown} />
                <a id="YearBuilt_Continue" className="continueButton" onClick={this.handleOnClick} ref={this.continueButton}>CONTINUE</a>
                   </div>
            </div>
        </React.Fragment>;
    }

    continueButton: any;
}
